export default __webpack_public_path__ + "static/media/video.4b6f405a.svg";